module.exports = __webpack_public_path__ + "img/star5.203a0b16.png";